var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-caption dashed" }, [_vm._v("调整前")]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form col-2 flex label" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.row.quantity || 0))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.row.defectQuantity || 0))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.row.normalQuantity || 0))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption dashed" }, [_vm._v("调整")]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form col-2 flex label" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c(
              "el-radio-group",
              {
                staticClass: "inline-block",
                on: { change: _vm.selectDefectFlag },
                model: {
                  value: _vm.defectFlag,
                  callback: function($$v) {
                    _vm.defectFlag = $$v
                  },
                  expression: "defectFlag"
                }
              },
              [
                _c("el-radio", { attrs: { label: true } }, [_vm._v("不良品")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: false } }, [_vm._v("良品")])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c("el-input", {
              staticClass: "inline-block width-1x",
              attrs: { type: "number", min: "0" },
              on: { change: _vm.changeNormalQuantity },
              model: {
                value: _vm.quantity,
                callback: function($$v) {
                  _vm.quantity = $$v
                },
                expression: "quantity"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "inline-block" }, [
              _vm._v(_vm._s(_vm.row.unit || ""))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.row.specificFlag
        ? _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-value" }, [
              _c(
                "a",
                {
                  staticClass: "font-blue",
                  on: {
                    click: function($event) {
                      _vm.doCreateSpecific()
                    }
                  }
                },
                [_vm._v("个体配件(" + _vm._s(_vm.specificAccList.length) + ")")]
              )
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption dashed" }, [_vm._v("调整后")]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form col-2 flex label " }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.row.quantity || 0))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.adjustedDefectQuantity || 0))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.adjustedNormalQuantity || 0))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption dashed" }, [_vm._v("其他")]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form label" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(8),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _c("el-input", {
              attrs: { type: "textarea" },
              model: {
                value: _vm.memo,
                callback: function($$v) {
                  _vm.memo = $$v
                },
                expression: "memo"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("不良品数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("良品数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("增加")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("不良品数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("良品数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("备注")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50df3399", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50df3399","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shareAcc/StockQuantityChange.vue
// module id = 2830
// module chunks = 0